import { Text } from "@clipboard-health/ui-components";
import { type ReactElement } from "react";

import { type CellGridItemProps } from "./types";

export function TypographyCell<T>(props: CellGridItemProps<T>): ReactElement {
  const { title } = props;
  return <Text variant="body2">{title}</Text>;
}
